import React from 'react';
import styled from '@emotion/styled';
import { useButton } from '~Hooks';

const Wrapper = styled.div<{
  touching: boolean;
}>`
  position: relative;
  border: none;
  border-radius: 0.75rem;
  background: rgba(100, 100, 100, 0.3);
  color: #fff;
  font-size: 1.25rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 0.8;
  transition: all 0.2s;

  ${({ touching }) =>
    touching &&
    `
    background: rgba(140, 140, 140, 0.4);
    outline: 2px solid rgba(100, 100, 100, 0.6);
    transform: scale(0.95);
    transition: all 0s;
  `}
`;

interface Props {
  value: string;
  onClick: (value: string) => void;
}

const NumpadButton: React.FC<Props> = ({ value, onClick }) => {
  const handlers = useButton({
    onClick: () => {
      onClick(value);
    },
  });

  return <Wrapper {...handlers}>{value}</Wrapper>;
};

export default NumpadButton;
